import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { Grid2 } from "@mui/material";
import { useEffect, useState } from "react";
import { PrimaryTooltip } from "../../../Components/StyledComponent";

const ExpandAllButton = ({ selectedTab, onToggle }) => {

    const [expandAll, setExpandAll] = useState(false);

    const handleToggleAll = () => {
        setExpandAll((prev) => !prev);
    };

    useEffect(() => {
        onToggle(expandAll);
    }, [expandAll])

    useEffect(() => {
        setExpandAll(false);
    }, [selectedTab])

    return (
        <PrimaryTooltip
            title={expandAll ? 'Collapse All' : 'Expand All'}
            placement="bottom"
        >
            <Grid2
                container
                flexDirection={'column'}
                sx={{
                    position: 'relative',
                    height: '15px',
                    width: '15px',
                    cursor: 'pointer',
                    "&:hover svg": {
                        color: '#4D44D8',
                    },
                }}
                onClick={handleToggleAll}
            >
                <ExpandMoreIcon
                    fontSize="medium"
                    sx={{
                        position: 'absolute',
                        top: '-2.5px',
                        left: 0,
                        transform: expandAll ? "rotate(180deg)" : "rotate(0deg)",
                        transition: "transform 0.2s",
                        color: '#686868',
                    }}
                />
                <ExpandMoreIcon
                    fontSize="medium"
                    sx={{
                        position: 'absolute',
                        top: '2.5px',
                        left: 0,
                        transform: expandAll ? "rotate(180deg)" : "rotate(0deg)",
                        transition: "transform 0.2s",
                        color: '#686868',
                    }}
                />
            </Grid2>
        </PrimaryTooltip>
    )

}

export default ExpandAllButton;
